export default "9154c023a8fc3e94.svg"